import Swal from 'sweetalert2'
import Color from 'constants/color.constants'
import { removeCookie } from 'helper/cookie'
import isObject from 'lodash/isObject'

export const handleError = (err, onClose) => {
  let handleClose = {}
  let notiDetail = {}
  if (err.status === 403 || err.status === 401) {
    handleClose = {
      didClose: () => {
        removeCookie('access_token_admin')
        window.location.reload()
      },
      showConfirmButton: false,
      timer: undefined,
    }
  } else if (err.status !== 404) {
    handleClose = onClose || {
      showConfirmButton: false,
      timer: 1500,
    }
  }
  if (isObject(err)) {
    notiDetail = {
      html: `
        <h2 style="color: ${Color.danger}; display: contents">Status Code ${err.status}</h2>
      `,
    }
  } else {
    notiDetail = {
      title: err,
    }
  }

  return Swal.fire({
    icon: 'error',
    showConfirmButton: false,
    timer: 1500,
    showClass: {
      popup: 'animate__animated animate__fadeInDown',
    },
    hideClass: {
      popup: 'animate__animated animate__fadeOutUp',
    },
    ...notiDetail,
    ...handleClose,
  })
}
